import React from "react"
import { useParams } from "react-router-dom"

import Grid, { Col } from "components/grid"
import { H4 } from "components/text"
import { Markdown } from "theme/markdown-html"

import { NoMatchPage } from "pages/no-match-page"
import { DrugFactsIndex } from "pages/drug-facts/drug-facts-types"

import contentfulIndex from "contentful/drugFacts.json"

const DrugFactDetails = () => {
  const { drugFactPath } = useParams<{ drugFactPath: string }>()
  const { drugFacts } = contentfulIndex as DrugFactsIndex

  const drugInfo = Object.values(drugFacts).find(drug => drugFactPath === drug.path)
  if (!drugInfo) {
    return <NoMatchPage />
  }

  return (
    <>
      <Grid rowProps={{ justifyContent: "center" }} pt={4}>
        <Col cols={[4, 4, 12, 12]} py={5} textAlign="center">
          <H4>{drugInfo.title}</H4>
        </Col>
        <Col cols={[4, 4, 8, 8]}>
          <Markdown content={drugInfo.content} />
        </Col>
      </Grid>
    </>
  )
}

export default DrugFactDetails
